import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { Box } from "@domestika-dev/prudencio/dist/atoms/Layout";

import { insertScript, removeNode } from "../../../js/utils/functions";
import { RECAPTCHA_URL, RECAPTCHA_V2_ONLOAD_CALLBACK } from "../../../packs/grecaptcha";

const ReCaptchaV2 = ({ sitekey, currentLang, isMobile }) => {
  useEffect(() => {
    const url = `${RECAPTCHA_URL}?onload=${RECAPTCHA_V2_ONLOAD_CALLBACK}&render=explicit&hl=${currentLang}`;
    const script = insertScript(url);

    // cleaning:
    return () => {
      removeNode(script);
    };
  }, []);

  return (
    <Box
      className="g-recaptcha"
      id="reCaptchaV2"
      data-sitekey={sitekey}
      data-tabindex="0"
      data-size={isMobile ? "compact" : "normal"}
      paddingTop={6}
      paddingBottom={6}
    />
  );
};

ReCaptchaV2.propTypes = {
  sitekey: PropTypes.string.isRequired,
  currentLang: PropTypes.string,
  isMobile: PropTypes.bool.isRequired,
};

ReCaptchaV2.defaultProps = {
  currentLang: "es",
};

export default ReCaptchaV2;
